import * as api from '../lib/api';
import localStore from 'store';
import {types, getParent, flow} from 'mobx-state-tree';

const Auth = types
  .model('Auth', {
    authenticated: false,
    loading: false
  })
  .actions((self) => {
    const authenticate = flow(function* (user, isNew) {
      self.loading = true;
      try {
        const data = yield api[isNew ? 'signUp' : 'login'](user);
        localStore.set('token', data.token);
        self.authenticated = true;
        yield getParent(self).afterAuth();
        self.loading = false;
      } catch (error) {
        self.loading = false;
        throw error;
      }
    });
    const logout = () => {
      localStore.remove('token');
      self.authenticated = false;
      getParent(self).afterLogout();
    };
    return {authenticate, logout};
  });

export default Auth;
